/** PARTICIPATION PERMISSIONS  */

export const LIST_PARTICIPATION = 'CONSULTAR PARTICIPACAO'

export const CREATE_PARTICIPATION = 'CADASTRAR PARTICIPACAO'

export const UPDATE_PARTICIPATION = 'ALTERAR PARTICIPACAO'

export const DELETE_PARTICIPATION = 'EXCLUIR PARTICIPACAO'

export const APPROVE_PARTICIPATION = 'APROVAR PARTICIPACAO'

export const REPROVE_PARTICIPATION = 'REPROVAR PARTICIPACAO'

export const SHARE_PARTICIPATION = 'COMPARTILHAR PARTICIPACAO'

export const OWNER_ALL_PARTICIPATION = 'DONO TODA PARTICIPACAO'

export const CONSULT_ALL_PARTICIPATION = 'CONSULTAR TODA PARTICIPACAO'

/** SHARINGS PERMISSIONS  */

export const LIST_SHARING = 'CONSULTAR COMPARTILHAMENTO'

export const RESPOND_SHARING = 'RESPONDER COMPARTILHAMENTO'

export const LIST_SHARING_MANAGEMENT = 'CONSULTAR GESTAO COMPARTILHAMENTO'
export const CREATE_SHARING_MANAGEMENT = 'CADASTRAR GESTAO COMPARTILHAMENTO'
export const UPDATE_SHARING_MANAGEMENT = 'ALTERAR GESTAO COMPARTILHAMENTO'
export const DELETE_SHARING_MANAGEMENT = 'EXCLUIR GESTAO COMPARTILHAMENTO'

/** GUEST PERMISSIONS  */

export const LIST_PARTICIPANT = 'CONSULTAR PARTICIPANTE'

export const CREATE_PARTICIPANT = 'CADASTRAR PARTICIPANTE'

export const UPDATE_PARTICIPANT = 'ALTERAR PARTICIPANTE'

export const ENABLE_PARTICIPANT = 'HABILITAR PARTICIPANTE'

/** RULES PERMISSIONS  */

export const LIST_RULE = 'CONSULTAR REGRA'

export const CREATE_RULE = 'CADASTRAR REGRA'

export const ENABLE_RULE = 'HABILITAR REGRA'

/** CONTENT MANAGEMENT PERMISSIONS  */

export const CONTENT_MANAGEMENT = 'GERENCIAR PROGRAMAS INTERNALIZADOS'
